import './price.scss';

import { CSSProperties, useEffect, useState } from 'react';

import { useDevice } from '@/resources/hooks/useDevice';
import { useWebContext } from '@/resources/hooks/useWebContext';

import { calcDiscount } from '../../../../services/products';
import { useFormatMoney } from '../../../hooks/useFormatMoney';
import { useTextColor } from '../../../hooks/useTextColor';
import Discount, { discountType } from '../../discount/Discount';
import { AdvantageClubPrice } from '../advantageClubPrice/AdvantageClubPrice';

interface Props {
  price: number;
  defaultPrice: number;
  showDiscount?: boolean;
  absoluteDiscount?: boolean;
  rewardPrice?: number | null;
  discountType?: discountType;
  priceStyles?: CSSProperties;
  discountStyles?: CSSProperties;
  showPromotionalPricePronoum?: boolean;
}

const Price = ({
  price,
  defaultPrice,
  discountType,
  rewardPrice = 0,
  priceStyles = {},
  discountStyles = {},
  showDiscount = false,
  absoluteDiscount = false,
  showPromotionalPricePronoum = false,
}: Props) => {
  const {
    configs: { advantage_club },
  } = useWebContext();

  const { device } = useDevice();

  const biggerCharLimit = device === 'mobile' && !absoluteDiscount ? '100%' : '27ch';

  const formatedPrice = useFormatMoney(price);
  const formatedRewardPrice = useFormatMoney(rewardPrice ?? 0);
  const formatedDefaultPrice = useFormatMoney(defaultPrice);

  const backgroundColor = advantage_club?.bg_color ?? '#fff';
  const color = useTextColor(backgroundColor);

  const [hasDiscount, setHasDiscount] = useState<boolean>(
    () => calcDiscount(defaultPrice, price) > 0,
  );

  useEffect(() => setHasDiscount(calcDiscount(defaultPrice, price) > 0), [defaultPrice, price]);

  return (
    <div className="prices-wrapper flex-md-row flex-column gap-1">
      <div style={priceStyles} className={`price ${rewardPrice ? 'has-reward' : ''}`}>
        {hasDiscount && (
          <div
            className={`price-and-discount d-flex ${
              absoluteDiscount
                ? 'align-items-center justify-content-between'
                : 'align-items-end justify-content-end  flex-column-reverse'
            }`}
          >
            <div className="old-price">
              <span className="tag">{showPromotionalPricePronoum ? 'De:' : ''} R$ </span>
              <span className="value">{formatedDefaultPrice}</span>
            </div>

            {showDiscount && (
              <Discount
                price={price}
                type={discountType}
                style={discountStyles}
                defaultPrice={defaultPrice}
                isAbsolute={absoluteDiscount}
              />
            )}
          </div>
        )}
        <div className="updated-price" style={{ width: hasDiscount ? '' : '100%' }}>
          <span className="tag">R$ </span>
          <span
            className="value"
            style={{
              // eslint-disable-next-line no-nested-ternary
              fontSize: rewardPrice ? (formatedPrice.length > 6 ? '10pt' : '15pt') : '18pt',
            }}
          >
            {formatedPrice}
          </span>
        </div>
      </div>

      {!!rewardPrice && (
        <AdvantageClubPrice
          backgroundColor={backgroundColor}
          color={color}
          advantage_club={advantage_club}
          biggerCharLimit={biggerCharLimit}
          formatedRewardPrice={formatedRewardPrice}
          absoluteDiscount={absoluteDiscount}
          device={device}
        />
      )}
    </div>
  );
};

export default Price;
